import { DownloadAuthoringPdfMenuItem } from "authoring/routes/pdf/download-authoring-pdf-menu-item"

export function DownloadCustomerDifferencesPdf() {
    return (
        <DownloadAuthoringPdfMenuItem
            mode="differences"
            audience="external"
            label="Download customer PDF: differences"
            dataCy="download-customer-differences-pdf-menu-item"
        />
    )
}
